import React from 'react';
import { Box } from '@ublend-npm/aulaui-core';
import formatSpaceDuration from '@core/utils/formatSpaceDuration';

interface SpaceDurationProps {
  startDate?: string | null;
  endDate?: string | null;
  gap?: number | string;
}

const SpaceDuration = ({ startDate, endDate, gap = 2 }: SpaceDurationProps) => {
  const dateString = formatSpaceDuration(startDate, endDate);

  if (!dateString) return null;

  const [start, end, ...rest] = dateString.split(' | ');

  if (!start || !end || rest.length > 0) {
    return <>{dateString}</>;
  }

  const spacing = typeof gap === 'number' ? `${gap}px` : gap;

  return (
    <>
      {start}
      <Box component="span" sx={{ mx: spacing }}>
        |
      </Box>
      {end}
    </>
  );
};

export default SpaceDuration;
